import FlexChild from "layouts/flex/FlexChild";
import style from "./SalesTodayStatus.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import Inline from "layouts/container/Inline";
import clsx from "classnames";
import Dummy from "components/Dummy";
import { useEffect, useState } from "react";
import { adminRequester } from "App";

function StoreStatistic() {
  // const formattedToday = `${year}년 ${month}월 ${date}일`;
  const [user, setUser] = useState();
  const [stores, setStores] = useState([]);
  const [store, setStore] = useState();
  const [mounted, setMounted] = useState(false);
  const [summary, setSummary] = useState();
  // const { isMobile } = useContext(BrowserDetectContext);

  const start_date = new Date();
  start_date.setMonth(start_date.getMonth() - 1);
  start_date.setDate(1);
  const end_date = new Date();
  end_date.setMonth(end_date.getMonth() + 1);
  end_date.setDate(0);

  useEffect(() => {
    setMounted(true);
    adminRequester.getStores({}, ({ stores }) => {
      setStores(stores);
      setStore(stores?.[0]);
    });
    adminRequester.getCurrentUser(({ user }) => setUser(user));
  }, []);

  useEffect(() => {
    if (mounted && user && store) {
      const data = {
        status: "adjustment",
        store_id: store.id,
        start_date: start_date || new Date(),
        end_date: end_date || new Date(),
      };
      if (user.role === "member") {
        data.store_id = user.store_id;
      }
      adminRequester.getStatistic(data, ({ data }) => setSummary(data?.[0]));
    }
  }, [mounted, user, store]);

  const Content = (props) => {
    const { color, minus, title, amount } = props;
    return (
      <div className={clsx(style.contentArea, { [style.bgColor]: color })}>
        <HorizontalFlex>
          <FlexChild>
            <P size={15}>{title}</P>
          </FlexChild>
          <FlexChild justifyContent={"flex-end"}>
            {minus && <div className={style.minus}>-</div>}
            <Dummy width={10} />
            <Inline>
              <P size={20} weight={"bold"}>
                {amount?.toLocaleString("ko")}
              </P>
              <P> </P>
            </Inline>
          </FlexChild>
        </HorizontalFlex>
      </div>
    );
  };

  return (
    <div className={style.container}>
      <VerticalFlex height="100%">
        <FlexChild height="max-content">
          <div className={style.label}>
            <HorizontalFlex gap={20} justifyContent="flex-start">
              <FlexChild>
                <Inline>
                  <P size={15} color="aqua">
                    [{store?.name}]
                  </P>
                  <P size={15}> 해당월 정산 금액</P>
                </Inline>
              </FlexChild>
              {user?.role !== "member" && (
                <FlexChild width="max-content">
                  <select
                    value={store?.id}
                    onChange={(e) =>
                      setStore(
                        stores.find((store) => store.id === e.target.value)
                      )
                    }
                  >
                    {stores?.map((store) => (
                      <option key={store?.id} value={store?.id}>
                        {store.name}
                      </option>
                    ))}
                  </select>
                </FlexChild>
              )}
            </HorizontalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <div className={style.contentWrap} style={{ height: "100%" }}>
            <HorizontalFlex height="100%">
              <VerticalFlex
                border={"1px solid black"}
                borderRadius={"5px"}
                padding={"20px 0"}
              >
                <FlexChild>
                  <VerticalFlex>
                    <FlexChild width={"90%"}>
                      <Content
                        title={"결제금액"}
                        amount={Number(summary?.get || 0)}
                      />
                    </FlexChild>
                    <FlexChild width={"90%"}>
                      <div className={style.line} />
                    </FlexChild>
                  </VerticalFlex>
                </FlexChild>
                <FlexChild>
                  <VerticalFlex>
                    <FlexChild width={"90%"}>
                      <Content
                        // minus
                        title={"환불금액"}
                        amount={Number(summary?.refund || 0)}
                      />
                    </FlexChild>
                    <FlexChild width={"90%"}>
                      <div className={style?.line} />
                    </FlexChild>
                  </VerticalFlex>
                </FlexChild>
                <FlexChild>
                  <VerticalFlex>
                    <FlexChild width={"90%"}>
                      <Content
                        color
                        title={"총매출"}
                        amount={Number(summary?.total || 0)}
                      />
                    </FlexChild>
                    <FlexChild width={"90%"}>
                      <div className={style.line} />
                    </FlexChild>
                  </VerticalFlex>
                </FlexChild>
              </VerticalFlex>
            </HorizontalFlex>
          </div>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default StoreStatistic;
